import { ManufacturerSystem } from "src/components/shared-components/enum/enumMisc";

export class ExtraInfoBlackBox {
  public blockReaded: string = "";
  public manufacturer: ManufacturerSystem;

  constructor() { }
}
